module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/page-key-words-result/1113.png"
    }
  }, [_c('div', {
    staticClass: "top",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "area"
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v("\n        您下半年的科研关键词是:"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "key-word"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-384caa39","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageKeyWordsReslut/index.vue
// module id = 1602
// module chunks = 8